import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { IconButton } from "components/common";
import { FileListContainer, ListHeader, ListBody, FileListItem, FileName, DragMessage } from "../styled-components";
const ACCEPTED_FILE_TYPES = {
  "application/yaml": [".yml", ".yaml"],
  "application/zip": [".zip"]
};
function FileList({ files, setFiles, onNameClick, invalidFileNames = void 0 }) {
  const { t } = useTranslation("enterprise_security_sigma");
  const getFileNameWithID = (fileName) => `${uuidv4()}.${fileName}`;
  const onDrop = useCallback(
    (acceptedFiles) => {
      const auxAcceptedFiles = acceptedFiles.map((file) => {
        const extension = file.name.split(".").pop();
        const type = Object.keys(ACCEPTED_FILE_TYPES).find(
          (key) => ACCEPTED_FILE_TYPES[key].includes(`.${extension}`)
        );
        return new File([file], getFileNameWithID(file.name), { type });
      }).filter((file) => !!file.type);
      setFiles((prev) => {
        const existingNames = new Set(prev.map((f) => f.name.split(".").slice(1).join(".")));
        return [...prev, ...auxAcceptedFiles.filter((f) => !existingNames.has(f.name.split(".").slice(1).join(".")))];
      });
    },
    [setFiles]
  );
  const { getRootProps, getInputProps, isDragActive, isFileDialogActive, open } = useDropzone({
    accept: ACCEPTED_FILE_TYPES,
    noClick: true,
    onDrop
  });
  const handleNameClick = (file) => (e) => {
    e.stopPropagation();
    onNameClick(file);
  };
  const onRemoveFile = useCallback(
    (fileName) => {
      setFiles(files.filter((file) => file.name !== fileName));
    },
    [files, setFiles]
  );
  return /* @__PURE__ */ React.createElement(FileListContainer, null, /* @__PURE__ */ React.createElement(ListHeader, null, t("file_list.selected_files"), " ", /* @__PURE__ */ React.createElement(IconButton, { name: "add", title: t("file_list.add_rules"), onClick: open })), /* @__PURE__ */ React.createElement(ListBody, { ...getRootProps({ style: { cursor: "default" } }), $isDragActive: isDragActive || isFileDialogActive }, files.map((file) => /* @__PURE__ */ React.createElement(
    FileListItem,
    {
      key: file.name,
      role: "listitem",
      $hasError: invalidFileNames == null ? void 0 : invalidFileNames.has(file.name),
      onClick: handleNameClick(file)
    },
    /* @__PURE__ */ React.createElement(
      IconButton,
      {
        name: "close",
        title: t("file_list.remove_file"),
        onClick: (e) => {
          e.stopPropagation();
          onRemoveFile(file.name);
        },
        size: "sm"
      }
    ),
    /* @__PURE__ */ React.createElement(FileName, { role: "link", title: t("file_list.file_name") }, file.name.split(".").slice(1).join("."))
  )), /* @__PURE__ */ React.createElement("input", { ...getInputProps({ id: "ruleFiles", "aria-label": t("file_list.drop_zone") }) }), files.length < 1 && /* @__PURE__ */ React.createElement(DragMessage, null, t("file_list.drag_drop"))));
}
export default FileList;
